import React from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { SingleNotificationView } from '..';
import { addIdToNotificationAdminConfig, removeIdFromNotificationAdminConfig } from '../../../../../helpers/notificationAdmin';

import { NotificationAdminContainer } from '../../style';

import { store } from '../../../../../redux/store';

interface NotificationDescriptionProps {
  filteredNotificationListAdmin: AppConfig.NotificationAdmin[];
}

/**
 * Komponent renderujący całe description czyli środek dla notyfikacji
 *
 */
const NotificationDescription = ({ filteredNotificationListAdmin }: NotificationDescriptionProps): JSX.Element | null => {
  const userId = store.getState().Auth.user.id?.toString() ?? '';
  const handleChange = (e: CheckboxChangeEvent, value: AppConfig.NotificationAdmin['id']) =>
    e.target.checked ? addIdToNotificationAdminConfig(value, userId) : removeIdFromNotificationAdminConfig(value, userId);

  return (
    <NotificationAdminContainer>
      {filteredNotificationListAdmin.map((notificationAdmin, index) => (
        <SingleNotificationView
          key={notificationAdmin.id}
          id={notificationAdmin.id}
          title={notificationAdmin.title}
          message={notificationAdmin.message}
          alwaysDisplay={notificationAdmin.alwaysDisplay}
          handleChange={handleChange}
          isFirstChild={index === 0}
        />
      ))}
    </NotificationAdminContainer>
  );
};

export default NotificationDescription;
